"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/referral-campaign.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Freferral-campaign.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.redemptionCriteriaToJSON = exports.redemptionCriteriaFromJSON = exports.BasicRewards = exports.StickerImage = exports.StickerImageUrls = exports.SnapchatStickerImages = exports.SnapchatSharingContent = exports.SocialContent = exports.Image = exports.CellContent = exports.RedeemerCampaignContent = exports.CampaignContentLabels = exports.CampaignContent = exports.ReferralCampaign = exports.RedemptionCriteria = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.referral.proto';
var RedemptionCriteria;
(function (RedemptionCriteria) {
    RedemptionCriteria["INVALID_REDEMPTION_CRITERIA"] = "INVALID_REDEMPTION_CRITERIA";
    RedemptionCriteria["FAMILY_KYCED"] = "FAMILY_KYCED";
    RedemptionCriteria["FUNDED"] = "FUNDED";
    RedemptionCriteria["ONBOARDED"] = "ONBOARDED";
    RedemptionCriteria["JOINED_BLACK_TIER"] = "JOINED_BLACK_TIER";
    RedemptionCriteria["RECEIVED_DIRECT_DEPOSIT"] = "RECEIVED_DIRECT_DEPOSIT";
    RedemptionCriteria["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RedemptionCriteria || (exports.RedemptionCriteria = RedemptionCriteria = {}));
function createBaseReferralCampaign() {
    return {
        id: '',
        title: '',
        content: exports.CampaignContent.fromPartial({}),
        redeemerContent: exports.RedeemerCampaignContent.fromPartial({}),
        startsAtMs: '0',
        expiresAtMs: '0',
        basicRewards: undefined,
        termsUrl: '',
    };
}
exports.ReferralCampaign = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            content: isSet(object.content)
                ? exports.CampaignContent.fromJSON(object.content)
                : exports.CampaignContent.fromPartial({}),
            redeemerContent: isSet(object.redeemerContent)
                ? exports.RedeemerCampaignContent.fromJSON(object.redeemerContent)
                : exports.RedeemerCampaignContent.fromPartial({}),
        };
        if (isSet(object.startsAtMs)) {
            message.startsAtMs = globalThis.String(object.startsAtMs);
        }
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        if (isSet(object.basicRewards)) {
            message.basicRewards = exports.BasicRewards.fromJSON(object.basicRewards);
        }
        if (isSet(object.termsUrl)) {
            message.termsUrl = globalThis.String(object.termsUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.content !== undefined) {
            obj.content = exports.CampaignContent.toJSON(message.content);
        }
        if (message.redeemerContent !== undefined) {
            obj.redeemerContent = exports.RedeemerCampaignContent.toJSON(message.redeemerContent);
        }
        if (message.startsAtMs !== undefined && message.startsAtMs !== '0') {
            obj.startsAtMs = message.startsAtMs;
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.basicRewards !== undefined) {
            obj.basicRewards = exports.BasicRewards.toJSON(message.basicRewards);
        }
        if (message.termsUrl !== undefined && message.termsUrl !== '') {
            obj.termsUrl = message.termsUrl;
        }
        return obj;
    },
    create(base) {
        return exports.ReferralCampaign.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralCampaign();
        message.id = object.id ?? '';
        message.title = object.title ?? '';
        message.content = (object.content !== undefined && object.content !== null)
            ? exports.CampaignContent.fromPartial(object.content)
            : exports.CampaignContent.fromPartial({});
        message.redeemerContent =
            (object.redeemerContent !== undefined && object.redeemerContent !== null)
                ? exports.RedeemerCampaignContent.fromPartial(object.redeemerContent)
                : exports.RedeemerCampaignContent.fromPartial({});
        message.startsAtMs = object.startsAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.basicRewards = (object.basicRewards !== undefined && object.basicRewards !== null)
            ? exports.BasicRewards.fromPartial(object.basicRewards)
            : undefined;
        message.termsUrl = object.termsUrl ?? '';
        return message;
    },
};
function createBaseCampaignContent() {
    return {
        cell: exports.CellContent.fromPartial({}),
        header: exports.Image.fromPartial({}),
        body: '',
        social: undefined,
        inviteMessage: '',
        rewardLabel: '',
        disclaimer: '',
        labels: undefined,
    };
}
exports.CampaignContent = {
    fromJSON(object) {
        const message = {
            cell: isSet(object.cell) ? exports.CellContent.fromJSON(object.cell) : exports.CellContent.fromPartial({}),
            header: isSet(object.header) ? exports.Image.fromJSON(object.header) : exports.Image.fromPartial({}),
            body: isSet(object.body) ? globalThis.String(object.body) : '',
        };
        if (isSet(object.social)) {
            message.social = exports.SocialContent.fromJSON(object.social);
        }
        if (isSet(object.inviteMessage)) {
            message.inviteMessage = globalThis.String(object.inviteMessage);
        }
        if (isSet(object.rewardLabel)) {
            message.rewardLabel = globalThis.String(object.rewardLabel);
        }
        if (isSet(object.disclaimer)) {
            message.disclaimer = globalThis.String(object.disclaimer);
        }
        if (isSet(object.labels)) {
            message.labels = exports.CampaignContentLabels.fromJSON(object.labels);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cell !== undefined) {
            obj.cell = exports.CellContent.toJSON(message.cell);
        }
        if (message.header !== undefined) {
            obj.header = exports.Image.toJSON(message.header);
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        if (message.social !== undefined) {
            obj.social = exports.SocialContent.toJSON(message.social);
        }
        if (message.inviteMessage !== undefined && message.inviteMessage !== '') {
            obj.inviteMessage = message.inviteMessage;
        }
        if (message.rewardLabel !== undefined && message.rewardLabel !== '') {
            obj.rewardLabel = message.rewardLabel;
        }
        if (message.disclaimer !== undefined && message.disclaimer !== '') {
            obj.disclaimer = message.disclaimer;
        }
        if (message.labels !== undefined) {
            obj.labels = exports.CampaignContentLabels.toJSON(message.labels);
        }
        return obj;
    },
    create(base) {
        return exports.CampaignContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCampaignContent();
        message.cell = (object.cell !== undefined && object.cell !== null)
            ? exports.CellContent.fromPartial(object.cell)
            : exports.CellContent.fromPartial({});
        message.header = (object.header !== undefined && object.header !== null)
            ? exports.Image.fromPartial(object.header)
            : exports.Image.fromPartial({});
        message.body = object.body ?? '';
        message.social = (object.social !== undefined && object.social !== null)
            ? exports.SocialContent.fromPartial(object.social)
            : undefined;
        message.inviteMessage = object.inviteMessage ?? '';
        message.rewardLabel = object.rewardLabel ?? '';
        message.disclaimer = object.disclaimer ?? '';
        message.labels = (object.labels !== undefined && object.labels !== null)
            ? exports.CampaignContentLabels.fromPartial(object.labels)
            : undefined;
        return message;
    },
};
function createBaseCampaignContentLabels() {
    return { awardAmount: '', inviteButton: '' };
}
exports.CampaignContentLabels = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.awardAmount)) {
            message.awardAmount = globalThis.String(object.awardAmount);
        }
        if (isSet(object.inviteButton)) {
            message.inviteButton = globalThis.String(object.inviteButton);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.awardAmount !== undefined && message.awardAmount !== '') {
            obj.awardAmount = message.awardAmount;
        }
        if (message.inviteButton !== undefined && message.inviteButton !== '') {
            obj.inviteButton = message.inviteButton;
        }
        return obj;
    },
    create(base) {
        return exports.CampaignContentLabels.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCampaignContentLabels();
        message.awardAmount = object.awardAmount ?? '';
        message.inviteButton = object.inviteButton ?? '';
        return message;
    },
};
function createBaseRedeemerCampaignContent() {
    return { cell: exports.CellContent.fromPartial({}), header: exports.Image.fromPartial({}), body: '' };
}
exports.RedeemerCampaignContent = {
    fromJSON(object) {
        const message = {
            cell: isSet(object.cell) ? exports.CellContent.fromJSON(object.cell) : exports.CellContent.fromPartial({}),
            header: isSet(object.header) ? exports.Image.fromJSON(object.header) : exports.Image.fromPartial({}),
            body: isSet(object.body) ? globalThis.String(object.body) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cell !== undefined) {
            obj.cell = exports.CellContent.toJSON(message.cell);
        }
        if (message.header !== undefined) {
            obj.header = exports.Image.toJSON(message.header);
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemerCampaignContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemerCampaignContent();
        message.cell = (object.cell !== undefined && object.cell !== null)
            ? exports.CellContent.fromPartial(object.cell)
            : exports.CellContent.fromPartial({});
        message.header = (object.header !== undefined && object.header !== null)
            ? exports.Image.fromPartial(object.header)
            : exports.Image.fromPartial({});
        message.body = object.body ?? '';
        return message;
    },
};
function createBaseCellContent() {
    return { image: exports.Image.fromPartial({}), text: '' };
}
exports.CellContent = {
    fromJSON(object) {
        const message = {
            image: isSet(object.image) ? exports.Image.fromJSON(object.image) : exports.Image.fromPartial({}),
            text: isSet(object.text) ? globalThis.String(object.text) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.image !== undefined) {
            obj.image = exports.Image.toJSON(message.image);
        }
        if (message.text !== '') {
            obj.text = message.text;
        }
        return obj;
    },
    create(base) {
        return exports.CellContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCellContent();
        message.image = (object.image !== undefined && object.image !== null)
            ? exports.Image.fromPartial(object.image)
            : exports.Image.fromPartial({});
        message.text = object.text ?? '';
        return message;
    },
};
function createBaseImage() {
    return { url: '', url2x: '', url3x: '' };
}
exports.Image = {
    fromJSON(object) {
        const message = {
            url: isSet(object.url) ? globalThis.String(object.url) : '',
            url2x: isSet(object.url2x) ? globalThis.String(object.url2x) : '',
            url3x: isSet(object.url3x) ? globalThis.String(object.url3x) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== '') {
            obj.url = message.url;
        }
        if (message.url2x !== '') {
            obj.url2x = message.url2x;
        }
        if (message.url3x !== '') {
            obj.url3x = message.url3x;
        }
        return obj;
    },
    create(base) {
        return exports.Image.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseImage();
        message.url = object.url ?? '';
        message.url2x = object.url2x ?? '';
        message.url3x = object.url3x ?? '';
        return message;
    },
};
function createBaseSocialContent() {
    return { snap: undefined };
}
exports.SocialContent = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.snap)) {
            message.snap = exports.SnapchatSharingContent.fromJSON(object.snap);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.snap !== undefined) {
            obj.snap = exports.SnapchatSharingContent.toJSON(message.snap);
        }
        return obj;
    },
    create(base) {
        return exports.SocialContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSocialContent();
        message.snap = (object.snap !== undefined && object.snap !== null)
            ? exports.SnapchatSharingContent.fromPartial(object.snap)
            : undefined;
        return message;
    },
};
function createBaseSnapchatSharingContent() {
    return { stickerImages: undefined };
}
exports.SnapchatSharingContent = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.stickerImages)) {
            message.stickerImages = exports.SnapchatStickerImages.fromJSON(object.stickerImages);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stickerImages !== undefined) {
            obj.stickerImages = exports.SnapchatStickerImages.toJSON(message.stickerImages);
        }
        return obj;
    },
    create(base) {
        return exports.SnapchatSharingContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSnapchatSharingContent();
        message.stickerImages = (object.stickerImages !== undefined && object.stickerImages !== null)
            ? exports.SnapchatStickerImages.fromPartial(object.stickerImages)
            : undefined;
        return message;
    },
};
function createBaseSnapchatStickerImages() {
    return {
        androidUrls: undefined,
        androidUrl: undefined,
        iosUrls: undefined,
        iosUrl: undefined,
        image: exports.StickerImage.fromPartial({}),
    };
}
exports.SnapchatStickerImages = {
    fromJSON(object) {
        const message = {
            image: isSet(object.image)
                ? exports.StickerImage.fromJSON(object.image)
                : exports.StickerImage.fromPartial({}),
        };
        if (isSet(object.androidUrls)) {
            message.androidUrls = exports.StickerImageUrls.fromJSON(object.androidUrls);
        }
        if (isSet(object.androidUrl)) {
            message.androidUrl = globalThis.String(object.androidUrl);
        }
        if (isSet(object.iosUrls)) {
            message.iosUrls = exports.StickerImageUrls.fromJSON(object.iosUrls);
        }
        if (isSet(object.iosUrl)) {
            message.iosUrl = globalThis.String(object.iosUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.androidUrls !== undefined) {
            obj.androidUrls = exports.StickerImageUrls.toJSON(message.androidUrls);
        }
        if (message.androidUrl !== undefined) {
            obj.androidUrl = message.androidUrl;
        }
        if (message.iosUrls !== undefined) {
            obj.iosUrls = exports.StickerImageUrls.toJSON(message.iosUrls);
        }
        if (message.iosUrl !== undefined) {
            obj.iosUrl = message.iosUrl;
        }
        if (message.image !== undefined) {
            obj.image = exports.StickerImage.toJSON(message.image);
        }
        return obj;
    },
    create(base) {
        return exports.SnapchatStickerImages.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSnapchatStickerImages();
        message.androidUrls = (object.androidUrls !== undefined && object.androidUrls !== null)
            ? exports.StickerImageUrls.fromPartial(object.androidUrls)
            : undefined;
        message.androidUrl = object.androidUrl ?? undefined;
        message.iosUrls = (object.iosUrls !== undefined && object.iosUrls !== null)
            ? exports.StickerImageUrls.fromPartial(object.iosUrls)
            : undefined;
        message.iosUrl = object.iosUrl ?? undefined;
        message.image = (object.image !== undefined && object.image !== null)
            ? exports.StickerImage.fromPartial(object.image)
            : exports.StickerImage.fromPartial({});
        return message;
    },
};
function createBaseStickerImageUrls() {
    return { teamPink: '', teamBlue: '', teamYellow: '', teamBlack: '' };
}
exports.StickerImageUrls = {
    fromJSON(object) {
        const message = {
            teamPink: isSet(object.teamPink) ? globalThis.String(object.teamPink) : '',
            teamBlue: isSet(object.teamBlue) ? globalThis.String(object.teamBlue) : '',
            teamYellow: isSet(object.teamYellow) ? globalThis.String(object.teamYellow) : '',
            teamBlack: isSet(object.teamBlack) ? globalThis.String(object.teamBlack) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.teamPink !== '') {
            obj.teamPink = message.teamPink;
        }
        if (message.teamBlue !== '') {
            obj.teamBlue = message.teamBlue;
        }
        if (message.teamYellow !== '') {
            obj.teamYellow = message.teamYellow;
        }
        if (message.teamBlack !== '') {
            obj.teamBlack = message.teamBlack;
        }
        return obj;
    },
    create(base) {
        return exports.StickerImageUrls.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickerImageUrls();
        message.teamPink = object.teamPink ?? '';
        message.teamBlue = object.teamBlue ?? '';
        message.teamYellow = object.teamYellow ?? '';
        message.teamBlack = object.teamBlack ?? '';
        return message;
    },
};
function createBaseStickerImage() {
    return { width: 0, height: 0, posX: 0, posY: 0 };
}
exports.StickerImage = {
    fromJSON(object) {
        const message = {
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            posX: isSet(object.posX) ? globalThis.Number(object.posX) : 0,
            posY: isSet(object.posY) ? globalThis.Number(object.posY) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.width !== 0) {
            obj.width = message.width;
        }
        if (message.height !== 0) {
            obj.height = message.height;
        }
        if (message.posX !== 0) {
            obj.posX = message.posX;
        }
        if (message.posY !== 0) {
            obj.posY = message.posY;
        }
        return obj;
    },
    create(base) {
        return exports.StickerImage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickerImage();
        message.width = object.width ?? 0;
        message.height = object.height ?? 0;
        message.posX = object.posX ?? 0;
        message.posY = object.posY ?? 0;
        return message;
    },
};
function createBaseBasicRewards() {
    return { referrerAward: amount_1.Amount.fromPartial({}), redeemerAward: amount_1.Amount.fromPartial({}) };
}
exports.BasicRewards = {
    fromJSON(object) {
        const message = {
            referrerAward: isSet(object.referrerAward)
                ? amount_1.Amount.fromJSON(object.referrerAward)
                : amount_1.Amount.fromPartial({}),
            redeemerAward: isSet(object.redeemerAward)
                ? amount_1.Amount.fromJSON(object.redeemerAward)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referrerAward !== undefined) {
            obj.referrerAward = amount_1.Amount.toJSON(message.referrerAward);
        }
        if (message.redeemerAward !== undefined) {
            obj.redeemerAward = amount_1.Amount.toJSON(message.redeemerAward);
        }
        return obj;
    },
    create(base) {
        return exports.BasicRewards.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicRewards();
        message.referrerAward = (object.referrerAward !== undefined && object.referrerAward !== null)
            ? amount_1.Amount.fromPartial(object.referrerAward)
            : amount_1.Amount.fromPartial({});
        message.redeemerAward = (object.redeemerAward !== undefined && object.redeemerAward !== null)
            ? amount_1.Amount.fromPartial(object.redeemerAward)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function redemptionCriteriaFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REDEMPTION_CRITERIA':
            return RedemptionCriteria.INVALID_REDEMPTION_CRITERIA;
        case 1:
        case 'FAMILY_KYCED':
            return RedemptionCriteria.FAMILY_KYCED;
        case 2:
        case 'FUNDED':
            return RedemptionCriteria.FUNDED;
        case 3:
        case 'ONBOARDED':
            return RedemptionCriteria.ONBOARDED;
        case 4:
        case 'JOINED_BLACK_TIER':
            return RedemptionCriteria.JOINED_BLACK_TIER;
        case 6:
        case 'RECEIVED_DIRECT_DEPOSIT':
            return RedemptionCriteria.RECEIVED_DIRECT_DEPOSIT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RedemptionCriteria.UNRECOGNIZED;
    }
}
exports.redemptionCriteriaFromJSON = redemptionCriteriaFromJSON;
function redemptionCriteriaToJSON(object) {
    switch (object) {
        case RedemptionCriteria.INVALID_REDEMPTION_CRITERIA:
            return 'INVALID_REDEMPTION_CRITERIA';
        case RedemptionCriteria.FAMILY_KYCED:
            return 'FAMILY_KYCED';
        case RedemptionCriteria.FUNDED:
            return 'FUNDED';
        case RedemptionCriteria.ONBOARDED:
            return 'ONBOARDED';
        case RedemptionCriteria.JOINED_BLACK_TIER:
            return 'JOINED_BLACK_TIER';
        case RedemptionCriteria.RECEIVED_DIRECT_DEPOSIT:
            return 'RECEIVED_DIRECT_DEPOSIT';
        case RedemptionCriteria.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.redemptionCriteriaToJSON = redemptionCriteriaToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=referral-campaign.js.map